import type { FC, ReactElement } from "react";

import { cn } from "@/lib/utils";

interface FilterWrapperProps {
  children: ReactElement;
  classes?: string;
}

const FilterWrapper: FC<FilterWrapperProps> = ({ children, classes }) => {
  return (
    <div
      className={cn(
        "flex items-center gap-[2px] py-[6px] pl-[12px] pr-[10px] border border-zinc-200 rounded-[6px] text-xs font-[Geist] font-medium",
        classes
      )}
    >
      {children}
    </div>
  );
};

export default FilterWrapper;
